import {Circle, FilterList} from "@mui/icons-material";
import {
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  ToggleButton,
  ToggleButtonGroup,
  Box,
  IconButton,
} from "@mui/material";
import {LineSeriesType} from "@mui/x-charts";
import {truncateSx} from "@util";
import {useState} from "react";

const SeriesToggle = ({
  series,
  selection,
  layout = "buttons",
  onChange,
}: {
  series: LineSeriesType[];
  selection: string[];
  layout?: "buttons" | "menu";
  onChange: (valus: string[]) => void;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleChange = (
    _e: React.MouseEvent<HTMLElement>,
    values: string[],
  ) => {
    if (values.length === 0) return;
    onChange(values);
  };

  const handleToggle = (e: React.MouseEvent<HTMLElement>, value: string) => {
    e.stopPropagation();
    const newSelection = selection.includes(value)
      ? selection.filter(s => s !== value)
      : [...selection, value];
    onChange(newSelection);
  };

  if (series.length <= 1) return <></>;

  if (layout === "menu") {
    return (
      <Box className="series-selector-container">
        <IconButton size="small" onClick={e => setAnchorEl(e.currentTarget)}>
          <FilterList fontSize="inherit" />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}>
          {series.map(s => (
            <MenuItem
              key={s.id}
              onClick={e => handleToggle(e, s.id!.toString())}
              selected={selection.includes(s.id!.toString())}>
              <ListItemIcon>
                <Circle fontSize="inherit" htmlColor={s.color} />
              </ListItemIcon>
              <ListItemText sx={truncateSx}>{s.id!.toString()}</ListItemText>
            </MenuItem>
          ))}
        </Menu>
      </Box>
    );
  }

  return (
    <ToggleButtonGroup
      className="series-selector-container"
      sx={{
        alignSelf: "center",
        overflow: "auto",
        maxWidth: "calc(100% - 32px)",
      }}
      value={selection}
      onChange={handleChange}
      size="small">
      {series.map(s => (
        <ToggleButton
          key={s.id}
          value={s.id!.toString()}
          sx={{
            textTransform: "none",
            py: 0.5,
            "&.Mui-selected": {
              backgroundColor: s.color + "33",
              color: s.color,
              "&:hover": {backgroundColor: s.color + "44"},
            },
          }}>
          {s.id!.toString()}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export {SeriesToggle};
